exports.generalValues = {
	APP_WEB: process.env.BASE_URL || 'http://localhost:8080',
	NODE_ENV: process.env.NODE_ENV || 'dev',
};
